import { render, staticRenderFns } from "./LanguagesTranslationsSettings.vue?vue&type=template&id=3dba21a9&scoped=true&"
import script from "./LanguagesTranslationsSettings.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsSettings.vue?vue&type=style&index=0&id=3dba21a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba21a9",
  null
  
)

export default component.exports